import { combineReducers } from "redux";

// ::::::::::: BASE ::::::::::://
import bailiffAuthReducer from "./bailiff/auth/bailiff_auth.reducer";
import bailiffDocumentReducer from "./bailiff/bailiff/document/bailiff_document.reducer";
import bailiffDialogReducer from "./bailiff/bailiff/dialog/bailiff_dialog.reducer";
import bailiffJobReducer from "./bailiff/bailiff/job/bailiff_job.reducer";
import orderBailiffReducer from "./bailiff/payment/order/order_bailiff.reducer";
import kycReducer from "./bailiff/kyc/kyc.reducer";
import navReducer from "./bailiff/nav/nav.reducer";
import defaultPaperReducer from "./bailiff/(default)/paper/default_paper.reducer";
// ::::::::::: VIVN USER ::::::::::://
import userAuthReducer from "./user/auth/user_auth.reducer";
import loginReducer from "./user/login/login.reducer";
import clientReducer from "./user/client/client.reducer";
import operatorReducer from "./user/operator/operator.reducer";
import userReducer from "./user/user/user.reducer";
import defaultSettingReducer from "./bailiff/(default)/setting/default_setting.reducer";
import defaultHackerReducer from "./bailiff/(default)/hacker/default_hacker.reducer";
import onboardReducer from "./bailiff/onboard/onboard.reducer";
import draftDialogReducer from "./bailiff/draft/dialog/draft_dialog.reducer";

const rootReducer = combineReducers({
  //auth
  userAuthReducer,
  bailiffAuthReducer,
  //
  loginReducer,
  clientReducer,
  operatorReducer,
  //operator
  userReducer,
  // bailiff
  bailiffDocumentReducer,
  bailiffDialogReducer,
  bailiffJobReducer,
  //draft
  draftDialogReducer,
  //order
  orderBailiffReducer,
  //kyc,
  kycReducer,
  defaultPaperReducer,
  defaultSettingReducer,
  defaultHackerReducer,

  //onboard
  onboardReducer,
  //nav
  navReducer,
});

export default rootReducer;
